import React, {useEffect, useState} from 'react';
import connection from '../../../connection';
import {NotificationManager} from 'react-notifications';
import moment from 'moment';
import ScaleLoader from 'react-spinners/ScaleLoader';
import {Container, Row, Col} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

// React Components
import LeagueCard from "../../../components/LeagueCard/LeagueCard";
import Header from '../../../components/Header/Header';
import BulletHeader from '../../../components/BulletHeader/BulletHeader';

// CSS Files
import './styles.css';

const override = `
    display: block;
    text-align: center;
    margin-top: 10%;
    `;

const EventSelection = (props) => {
   const [padelboxLeagues, setPadelboxLeagues] = useState([]);
   const [otherLeagues, setOtherLeagues] = useState([]);
   const [tournaments, settournaments] = useState([]);
   const [hasEnrollments, setHasEnrollments] = useState(false);
   const [loading, setLoading] = useState(true);
   const { t } = useTranslation();

   const calculateRemainingDays = (end_date) => {
      let today = moment().format('YYYY-MM-DD');
      let moment_end_date = moment(end_date);

      let remaining_days = moment_end_date.diff(today, 'days');

      if (remaining_days < 0) {
         return t("registration_page.registrations_closed");
      } else if (remaining_days === 0) {
         return t("registration_page.registrations_close_today");
      } else {
         return t("registration_page.event_deadline", { days: remaining_days });
      }
   };

   const submit = (data) => {
      props.onSubmit(data);
   }

   useEffect(() => {
      (async () => {
            try {
               let hasEnrollments = false;
               try {
                  hasEnrollments = await connection.get("v1/current_user/has_enrollments");
               } catch (e) {
               }

               setHasEnrollments(hasEnrollments);

               let [padelboxLeagues, otherLeagues, tournaments] = await Promise.all([
                 connection.get('v1/leagues/active_padelbox_editions.json'),
                 connection.get('v1/leagues/active_other_editions.json'),
                 connection.get('v1/tournaments/active_tournaments.json')
               ]);

               setPadelboxLeagues(padelboxLeagues);
               setOtherLeagues(otherLeagues);
               settournaments(tournaments);

               setLoading(false);
            } catch (e) {
               NotificationManager.error(t("common.form.errors.general"), t("common.error"), 4000);
            }
      })();
   }, []);

   return (
      <div>
         <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton />

         <Container>
            <Row>
               <Col className={"pb-3"} xs={12} sm={12}>
                  <BulletHeader text={t("registration_page.next_events")}/>
                  <p>{t("registration_page.select_event")}</p>
               </Col>
            </Row>
            <Row>
               <Col xs={12} sm={4}>
                  <BulletHeader text={t("registration_page.padelbox_league")}/>
                  <ScaleLoader
                     css={override}
                     sizeUnit={"px"}
                     size={30}
                     color={'#AFFF55'}
                     loading={loading}
                  />
                  {!loading && padelboxLeagues.length === 0 &&
                     <div className="alert alert-info" role="alert">{t("registration_page.no_events")}</div>
                  }

                  {!loading && padelboxLeagues.map((item, key) => {
                     let enrollment_data = item;
                     let league_team_type = "";

                     enrollment_data.isLeague = true;
                     enrollment_data.clubs = item.leagues[0].clubs;
                     enrollment_data.has_enrollments = hasEnrollments;

                     return <LeagueCard
                        key={key.toString()}
                        onClick={() => submit(enrollment_data)}
                        leagueNameClasses="card-games pb-3 mb-3"
                        leagueDate={t("registration_page.to_from", { from: item.start_date, to: item.end_date})}
                        leagueName={item.name}
                        leaguePoster={item.poster_url}
                     >
                        <p className="start-date-container start-date-text">{calculateRemainingDays(item.registration_end_date)}</p>
                     </LeagueCard>
                  })}
               </Col>
               <Col xs={12} sm={4}>
                  <BulletHeader text={t("registration_page.other_leagues")}/>
                  <ScaleLoader
                     css={override}
                     sizeUnit={"px"}
                     size={30}
                     color={'#AFFF55'}
                     loading={loading}
                  />
                  {!loading && otherLeagues.length === 0 &&
                     <div className="alert alert-info" role="alert">{t("registration_page.no_events")}</div>
                  }

                  {!loading && otherLeagues.map((item, key) => {
                     let enrollment_data = item;
                     let league_team_type = "";

                     enrollment_data.isLeague = true;
                     enrollment_data.clubs = item.leagues[0].clubs;
                     enrollment_data.has_enrollments = hasEnrollments;

                     return <LeagueCard
                        key={key.toString()}
                        onClick={() => submit(enrollment_data)}
                        leagueNameClasses="card-games pb-3 mb-3 outrasligas-background"
                        leagueDate={t("registration_page.to_from", { from: item.start_date, to: item.end_date})}
                        leagueName={item.name}
                        leaguePoster={item.poster_url}
                     >
                        <p className="start-date-container start-date-text">{calculateRemainingDays(item.registration_end_date)}</p>
                     </LeagueCard>
                  })}
               </Col>
               <Col xs={12} sm={4}>
                  <BulletHeader text={t("registration_page.tournaments")}/>
                  <ScaleLoader
                     css={override}
                     sizeUnit={"px"}
                     size={30}
                     color={'#afff55'}
                     loading={loading}
                  />
                  {!loading && tournaments.length === 0 &&
                     <div className="alert alert-info" role="alert">{t("registration_page.no_events")}</div>
                  }
                  {!loading && tournaments.map((tournament, key) => {
                     let enrollment_data = tournament;

                     enrollment_data.isLeague = false;
                     enrollment_data.clubs = tournament.clubs;

                     return <LeagueCard
                        key={key.toString()}
                        onClick={() => submit(enrollment_data)}
                        leagueNameClasses="card-games pb-3 mb-3 torneios-background"
                        leagueName={tournament.name}
                        leagueDate={t("registration_page.to_from", { from: tournament.start_date, to: tournament.end_date})}
                        leaguePoster={tournament.poster_url}
                     >
                        <p className="start-date-container start-date-text">{calculateRemainingDays(tournament.registration_end_date)}</p>
                     </LeagueCard>
                  })}

               </Col>
            </Row>
         </Container>
      </div>
   );
}

export default EventSelection;
